const GamepadEnum = {
  UP: 'up',
  DOWN: 'down',
  LEFT: 'left',
  RIGHT: 'right',
  LBUMP: 'lbump',
  RBUMP: 'rbump',
  START: 'start',
  SELECT: 'select',
  A: 'a',
  ESC: 'esc',
  R_UP: 'r_up',
  R_DOWN: 'r_down',
  R_LEFT: 'r_left',
  R_RIGHT: 'r_right',
  R_ANALOG_X: 'r_analog_x',
  R_ANALOG_Y: 'r_analog_y',
  L_ANALOG_X: 'l_analog_x',
  L_ANALOG_Y: 'l_analog_y',
}

export { GamepadEnum };
